import CatastoDB from "./databases/catasto";

export default {
  search (name: string) {
    const descriptions = Object.keys(CatastoDB);
    const matching = descriptions.filter(description => description.toUpperCase().includes(name.toUpperCase()));

    const result: { description?: string, code: string }[]  = [];
    for (const key of matching) {
      result.push({
        description: key,
        code: CatastoDB[key]
      });
    }

    return result;
  },
  searchByCode (catastoCode: string) {
    const description = Object.keys(CatastoDB).find(key => CatastoDB[key] === catastoCode);

    const result: { description?: string, code: string }[] = [];
    result.push({
      description: description,
      code: catastoCode
    });

    return result;
  }
};
